import { useEffect, useState } from 'react'
import { axiosClient } from 'src/services/axiosInstance'

export type TurboPickupConfiguration = {
  isActive?: boolean
  pickupId: string
  tagText: string
  linkUrl?: string
}

export type TurboPickupConfig = {
  configurations: TurboPickupConfiguration[]
}

const TURBO_PICKUP_CONTENT_TYPE = 'delivery-promises'
const TURBO_PICKUP_BUILDER = 'cms-site-app'
const TURBO_PICKUP_SECTION_NAME = '[Header] Tag Promocional Retirada Turbo'

type TurboPickupCmsPage = {
  sections?: Array<{
    name?: string
    data?: TurboPickupConfig
  }>
}

export function getTurboPickupSectionConfig(
  cmsData: TurboPickupCmsPage | null | undefined
) {
  return cmsData?.sections?.find(
    (section) => section.name === TURBO_PICKUP_SECTION_NAME
  )?.data
}

export function useTurboPickupConfig() {
  const [config, setConfig] = useState<TurboPickupConfig>()

  useEffect(() => {
    let isMounted = true

    axiosClient
      .get(
        `/api/cms/getPageData?builder=${TURBO_PICKUP_BUILDER}&contentType=${TURBO_PICKUP_CONTENT_TYPE}`
      )
      .then(({ data }) => {
        if (!isMounted) {
          return
        }

        setConfig(getTurboPickupSectionConfig(data))
      })
      .catch(() => {
        if (!isMounted) {
          return
        }

        setConfig(undefined)
      })

    return () => {
      isMounted = false
    }
  }, [])

  return config
}
